<template>
  <section>
    <nav-component :titulo="'Clientes'" :link="can('clientes.registrar') ? { path: '/agregar-cliente' } : null" :texto="'Agregar cliente'" />
    <div class="columns">
      <div class="column">
        <b-select v-model="perPage" @input="onPerPageChange">
          <option :value="5">5 por página</option>
          <option :value="10">10 por página</option>
          <option :value="15">15 por página</option>
          <option :value="20">20 por página</option>
          <option :value="null">Todos</option>
        </b-select>
      </div>
      <div class="column is-flex is-justify-content-end">
        <b-button type="is-primary" tag="a" :href="printHref" target="__blank" rel="noopener noreferrer">
          Imprimir
        </b-button>
      </div>
    </div>
    <b-table class="box" :data="clientes" :per-page="filasPorPagina" :paginated="usaPaginacion" :pagination-simple="false"
    :current-page="currentPage" :backend-pagination="usaPaginacion" :total="total" @page-change="onPageChange"
    :pagination-position="'bottom'" :default-sort-direction="'asc'" :pagination-rounded="true">
      <b-table-column field="nombre" label="Nombre del cliente">
        <template #header>
          <div class="clientes-header-filtro">
            <span>Nombre del cliente</span>
            <b-input v-model="filtros.nombre" size="is-small" @input="onFiltrosChange"></b-input>
          </div>
        </template>
        <template #default="props">
          {{ props.row.nombre }}
        </template>
      </b-table-column>

      <b-table-column field="ci" label="Cédula/RIF">
        <template #header>
          <div class="clientes-header-filtro">
            <span>Cédula/RIF</span>
            <b-input v-model="filtros.ci" size="is-small" @input="onFiltrosChange"></b-input>
          </div>
        </template>
        <template #default="props">
          {{ props.row.ci }}
        </template>
      </b-table-column>

      <b-table-column field="tipo" label="Tipo">
        <template #header>
          <div class="clientes-header-filtro">
            <span>Tipo</span>
            <b-input v-model="filtros.tipo" size="is-small" @input="onFiltrosChange"></b-input>
          </div>
        </template>
        <template #default="props">
          {{ props.row.tipo }}
        </template>
      </b-table-column>

      <b-table-column field="telefono" label="Teléfono">
        <template #header>
          <div class="clientes-header-filtro">
            <span>Teléfono</span>
            <b-input v-model="filtros.telefono" size="is-small" @input="onFiltrosChange"></b-input>
          </div>
        </template>
        <template #default="props">
          {{ props.row.telefono }}
        </template>
      </b-table-column>

      <b-table-column field="direccion" label="Dirección">
        <template #header>
          <div class="clientes-header-filtro">
            <span>Dirección</span>
            <b-input v-model="filtros.direccion" size="is-small" @input="onFiltrosChange"></b-input>
          </div>
        </template>
        <template #default="props">
          {{ props.row.direccion }}
        </template>
      </b-table-column>

      <b-table-column field="eliminar" label="Eliminar" v-slot="props" v-if="can('clientes.eliminar')">
        <b-button type="is-danger" icon-left="delete" @click="eliminar(props.row.id)">Eliminar</b-button>
      </b-table-column>

      <b-table-column field="editar" label="Editar" v-slot="props" v-if="can('clientes.editar')">
        <b-button type="is-info" icon-left="pen" @click="editar(props.row.id)">Editar</b-button>
      </b-table-column>
    </b-table>

    <div class="mt-4">
      <b-button type="is-warning" icon-left="eye" @click="abrirOcultos" v-if="can('clientes.obtener_ocultos')">
        Clientes eliminados
      </b-button>
    </div>

    <b-modal v-model="mostrarOcultos" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: 90vw; max-width: 900px">
        <header class="modal-card-head has-background-warning">
          <p class="modal-card-title has-text-white">Clientes eliminados</p>
          <button type="button" class="delete" @click="mostrarOcultos = false" />
        </header>
        <section class="modal-card-body">
          <p v-if="clientesOcultos.length === 0 && !cargandoOcultos" class="has-text-centered has-text-grey">
            No hay clientes eliminados.
          </p>
          <b-table v-if="clientesOcultos.length > 0" :data="clientesOcultos" hoverable>
            <b-table-column field="nombre" label="Nombre del cliente" v-slot="props">{{ props.row.nombre }}</b-table-column>
            <b-table-column field="ci" label="Cédula/RIF" v-slot="props">{{ props.row.ci }}</b-table-column>
            <b-table-column field="tipo" label="Tipo" v-slot="props">{{ props.row.tipo }}</b-table-column>
            <b-table-column field="telefono" label="Teléfono" v-slot="props">{{ props.row.telefono }}</b-table-column>
            <b-table-column field="direccion" label="Dirección" v-slot="props">{{ props.row.direccion }}</b-table-column>
            <b-table-column field="reactivar" label="Reactivar" v-slot="props" v-if="can('clientes.reactivar')">
              <b-button type="is-success" size="is-small" @click="reactivar(props.row.id)" :loading="props.row._reactivando">
                <b-icon icon="undo" />
                <span>Reactivar</span>
              </b-button>
            </b-table-column>
          </b-table>
        </section>
        <footer class="modal-card-foot">
          <b-button label="Cerrar" @click="mostrarOcultos = false" />
        </footer>
      </div>
    </b-modal>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>
<script>
import NavComponent from '../Extras/NavComponent'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

export default {
  name: "ClientesComponent",
  components: { NavComponent },

  data: () => ({
    cargando: false,
    clientes: [],
    clientesOcultos: [],
    mostrarOcultos: false,
    cargandoOcultos: false,
    perPage: 5,
    currentPage: 1,
    total: 0,
    busqueda: '',
    busquedaTimeout: null,
    filtros: {
      nombre: '',
      ci: '',
      tipo: '',
      telefono: '',
      direccion: '',
    },
  }),

  mounted() {
    this.obtenerClientes()
  },

  computed: {
    printHref() {
      let href = '#/pdf/clientes'
      const entries = Object.entries(this.filtros)
        .filter(([, valor]) => Boolean(String(valor || '').trim()))
      if (entries.length === 0) return href
      const params = new URLSearchParams(entries)
      return `${href}?${params.toString()}`
    },

    usaPaginacion() {
      return this.perPage !== null
    },
    filasPorPagina() {
      return this.perPage || this.total || 1
    },
  },

  methods: {
    formatoMonto(valor) {
      return Utiles.formatoMonto(valor)
    },

    eliminar(idCliente) {
      this.$buefy.dialog.confirm({
        title: 'Eliminar cliente',
        message: 'Seguro que quieres <b>eliminar</b> este cliente? Dejará de aparecer en el listado y en los formularios, pero su historial de ventas, cuentas, apartados y cotizaciones se conserva.',
        confirmText: 'Sí, eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.cargando = true
          HttpService.eliminar('clientes.php', {
            accion: 'eliminar',
            id: idCliente
          })
            .then(resultado => {
              if (resultado !== true) {
                const detalle = resultado && (resultado.error || resultado.mensaje)
                this.$buefy.toast.open({
                  type: 'is-danger',
                  message: detalle || 'Error al eliminar'
                })
                return
              }

              this.$buefy.toast.open({
                type: 'is-info',
                message: 'Cliente eliminado. Ya no aparece en el listado ni en los formularios.'
              })
              this.obtenerClientes()
            })
            .catch(() => {
              this.$buefy.toast.open({
                type: 'is-danger',
                message: 'Error al eliminar'
              })
            })
            .finally(() => {
              this.cargando = false
            })
        }
      })
    },

    editar(idCliente) {
      this.$router.push({
        name: "EditarCliente",
        params: { id: idCliente }
      })
    },

    abrirOcultos() {
      this.mostrarOcultos = true
      this.cargandoOcultos = true
      HttpService.obtenerConConsultas('clientes.php', { accion: 'obtener_ocultos' })
        .then(clientes => {
          this.clientesOcultos = (clientes || []).map(cliente => ({ ...cliente, _reactivando: false }))
        })
        .finally(() => {
          this.cargandoOcultos = false
        })
    },

    reactivar(idCliente) {
      const idx = this.clientesOcultos.findIndex(cliente => cliente.id === idCliente)
      if (idx >= 0) this.clientesOcultos[idx]._reactivando = true

      const fallar = () => {
        if (idx >= 0) this.clientesOcultos[idx]._reactivando = false
        this.$buefy.toast.open({ type: 'is-danger', message: 'Error al reactivar cliente.' })
      }

      HttpService.eliminar('clientes.php', { accion: 'reactivar', id: idCliente })
        .then(resultado => {
          if (resultado !== true) {
            fallar()
            return
          }

          if (idx >= 0) this.clientesOcultos.splice(idx, 1)
          this.$buefy.toast.open({ type: 'is-success', message: 'Cliente reactivado con éxito.' })
          this.obtenerClientes()
        })
        .catch(fallar)
    },

    obtenerClientes() {
      this.cargando = true
      let payload = {
        accion: "obtener",
        pagina: this.perPage === null ? null : this.currentPage,
        limite: this.perPage,
        busqueda: this.busqueda.trim() || null,
        filtros: this.filtros,
      }

      HttpService.obtenerConConsultas("clientes.php", payload)
        .then(resultado => {
          this.clientes = resultado.clientes || []
          this.total = resultado.total || 0
        })
        .finally(() => {
          this.cargando = false
        })
    },

    onFiltrosChange() {
      clearTimeout(this.busquedaTimeout)
      this.busquedaTimeout = setTimeout(() => {
        this.currentPage = 1
        this.obtenerClientes()
      }, 250)
    },

    onPageChange(page) {
      this.currentPage = page
      this.obtenerClientes()
    },

    onPerPageChange() {
      this.currentPage = 1
      this.obtenerClientes()
    }
  }
}
</script>

<style scoped>
.clientes-header-filtro {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 140px;
}

.clientes-header-filtro :deep(.input) {
  min-width: 0;
}
</style>
